import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";


// 查詢所有公司清單
export const queryCompaniesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020101")}`, method: 'post', data: ReqBody })
}

// 查詢單筆公司詳情
export const queryCompaniesInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020102")}`, method: 'post', data: ReqBody })
}

// 更新公司資料 before
export const B1020103Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020103",true)}`, method: 'post', data: ReqBody })
}

// 更新公司資料
export const updateCompaniesInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020103")}`, method: 'post', data: ReqBody })
}

//查詢公司下拉清單 B1000001
export const queryCompaniesListByType = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1000001'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1000001")}`, method: 'post', data: ReqBody })
}

// 查詢公司角色清單
export const queryCompaniesRoleList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020104")}`, method: 'post', data: ReqBody })
}

// 更新公司角色清單
export const updateCompaniesRoleFunc = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020105'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020105")}`, method: 'post', data: ReqBody })
}

// 查詢公司清單
export const queryCompanyList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010206'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010206")}`, method: 'post', data: ReqBody })
}

// 查詢公司標籤
export const queryCompanyTagList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020106'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020106")}`, method: 'post', data: ReqBody })
}

// 更新公司標籤
export const B1020107Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020107'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020107",true)}`, method: 'post', data: ReqBody })
}

export const updateCompanyTagList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1020107'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1020107")}`, method: 'post', data: ReqBody })
}